import AnimatedSuccess from './AnimatedSuccess.jsx'

export default AnimatedSuccess
